import { format } from "./format";

/**
 * A row or record count in the app's short notation — `950`, `50k`, `1.23m` —
 * the same one cell values use, so a count in a table header, a list column, and
 * a progress readout all read alike.
 *
 * Use it wherever the magnitude is the point and the exact figure is not: a
 * column narrow enough to truncate `1,234,567` loses more than the rounding
 * does. {@link formatBytes} is the equivalent for sizes.
 */
export const formatCount = (value: number): string =>
  format({ value, format: { kind: "NUMBER" }, style: "short" });
